/* eslint-disable array-callback-return */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { Component } from 'react';
import { DatePicker, Icon } from 'antd';
import moment from 'moment';


const { MonthPicker, RangePicker, WeekPicker } = DatePicker;

class Datepicker extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: new Date(),
            dateData: {
                'value': new Date()
            }
        };
    }
    componentDidMount() {
        this.setState((state) => ({ 'dateData': this.props.selectdata }));
    }

    componentDidUpdate(prevProps,pervState){
       
        if((prevProps.selectdata.value != this.props.selectdata.value)){
            this.setState((state)=>({ 'dateData': this.props.selectdata }))
        }
    }

    onChangeDate(date, dateString) {

        this.props.onselectChanges({ id: this.props.selectdata.name, text: dateString, name: this.props.selectdata.name, value: dateString, parrentMode: this.props.selectdata.parrentMode, parrentName: this.props.selectdata.parrentName });
    }

    // handleKeyPress = ($event) => {     if($event.key === 'Enter'){
    // this.props.onInputChanges({enter:true,name:$event.target.name,text:$event.tar
    // g et.value,value:$event.target.value});     }   } onChange($event) {
    // this.props.onInputChanges({enter:false,name:$event.target.name,text:$event.ta
    // r get.value,value:$event.target.value}); }

    defaultDate() {
        let value = this.state.dateData.value;

        if (value !== null && value !== undefined && value !== '') {
            return moment('2015-01-07');
        } else {
            return null;
        }
    }

    render() {
        let {value, disable} = this.state.dateData;
        // let value = this.state.dateData.value;
        if (this.props.selectdata.name === 'estimated_date_of_admission' || this.props.selectdata.name === 'date_of_surgery') {
            return (
            <DatePicker
                disabled={disable}
                
                // disabledDate={current => {
                //     return current && current < moment().subtract(1,'day');
                // }}
                value={(value !== undefined && value !== null && value !== '') ? moment(value) : null}
                placeholder={this.props.selectdata.placeholder}
                onChange={this
                    .onChangeDate
                    .bind(this)} />);
        }else if (this.props.selectdata.name === 'starttime' || this.props.selectdata.name === 'endtime') {
            return (<DatePicker
                
                disabled={disable}
                showTime 
                // disabledDate={current => {
                //     return current && current < moment().subtract(1,'day');
                // }}
                value={(value !== undefined && value !== null && value !== '') ? moment(value) : null}
                placeholder={this.props.selectdata.placeholder}
                onChange={this
                    .onChangeDate
                    .bind(this)} />);
        }else{
            return (<DatePicker
                
                disabled={disable}
                value={(value !== undefined && value !== null && value !== '') ? moment(value) : null}
                placeholder={this.props.selectdata.placeholder}
                onChange={this
                    .onChangeDate
                    .bind(this)} />); 
        }
    }
}

export default Datepicker;
